import styled, { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  :root {
    --bg: #f5f7fb;
    --surface: #ffffff;
    --ink: #101828;
    --muted: #475467;
    --primary: #0f6fff;
    --primary-dark: #0a54c2;
    --line: #d0d5dd;
    --radius: 12px;
    --shadow: 0 10px 30px rgba(16, 24, 40, 0.08);
  }

  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  html,
  body,
  #root {
    min-height: 100%;
  }

  body {
    font-family: "Inter", "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
    background: var(--bg);
    color: var(--ink);
    line-height: 1.6;
  }

  h1,
  h2,
  h3 {
    letter-spacing: -0.02em;
    line-height: 1.2;
    color: #0b1220;
  }

  h1 {
    font-size: clamp(2rem, 4.3vw, 3.1rem);
  }

  a {
    color: inherit;
  }
`;

export const Conatainer = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;

  @media screen and (max-width: 768px) {
    padding: 0 18px;
  }
`;

export const Button = styled.button.withConfig({
  shouldForwardProp: (prop) => !["primary", "big", "fontBig"].includes(prop),
})`
  border-radius: 12px;
  background: ${({ primary }) => (primary ? "var(--primary)" : "#101828")};
  white-space: nowrap;
  padding: ${({ big }) => (big ? "14px 26px" : "11px 20px")};
  color: #fff;
  font-size: ${({ fontBig }) => (fontBig ? "1rem" : "0.95rem")};
  font-weight: 700;
  letter-spacing: 0.01em;
  border: 1px solid transparent;
  cursor: pointer;
  box-shadow: 0 8px 18px rgba(15, 111, 255, 0.2);
  transition: all 0.2s ease;

  &:hover {
    transform: translateY(-1px);
    background: ${({ primary }) => (primary ? "var(--primary-dark)" : "#344054")};
  }
`;

export const Section = styled.section`
  padding: ${({ compact }) => (compact ? "56px 0" : "88px 0")};
`;

export default GlobalStyle;
